<template>
  <Listbox
    v-model="selected"
    as="div"
  >
    <ListboxLabel class="block text-sm font-medium text-gray-700">
      Find destination*
    </ListboxLabel>
    <div class="mt-1 relative">
      <ListboxButton
        v-if="place_id == null"
        class="relative w-full bg-white rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
      >
        <label
          for="search"
          class="sr-only"
        >Search Destination</label>
        <div class="relative">
          <div
            class="pointer-events-none absolute inset-y-0 left-0 pl-3 flex items-center"
          >
            <MagnifyingGlassIcon
              class="h-5 w-5 text-gray-400"
              aria-hidden="true"
            />
          </div>
          <input
            id="search"
            ref="searchDestinations"
            v-model="searchQuery"
            name="search"
            class="block w-full bg-white border z-10 border-gray-400 rounded-md py-2 pl-10 pr-3 text-sm placeholder-gray-500 focus:outline-none focus:text-gray-900 focus:placeholder-gray-400 focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            placeholder="Search for destination"
            type="search"
            list="destinations"
            v-text="Search"
          >
        </div>
        <span
          v-if=" selected.image !== null"
          class="flex items-center mt-2"
        >
          <img
            :src="selected.image"
            alt=""
            class="flex-shrink-0 h-4 w-6 mt-1.5"
          >
          <span class="ml-3 block truncate">{{ selected.name }}</span>
        </span>
        <span class="ml-3 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
          <ChevronUpDownIcon
            class="h-5 w-5 text-gray-400"
            aria-hidden="true"
          />
        </span>
      </ListboxButton>

      <transition
        leave-active-class="transition ease-in duration-100"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <ListboxOptions
          class="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm"
        >
          <!-- <ListboxOption disabled>
            <label
              for="search"
              class="sr-only"
            >Search Destination</label>
            <div class="relative">
              <div
                class="pointer-events-none absolute inset-y-0 left-0 pl-3 flex items-center"
              >
                <MagnifyingGlassIcon
                  class="h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
              </div>
              <input
                id="search"
                ref="searchDestinations"
                v-model="searchQuery"
                autoFocus
                name="search"
                class="block w-full bg-white border border-gray-300 rounded-md py-2 pl-10 pr-3 text-sm placeholder-gray-500 focus:outline-none focus:text-gray-900 focus:placeholder-gray-400 focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                placeholder="Search for destination"
                type="search"
                list="destinations"
                v-text="Search"
              >
            </div>
          </ListboxOption> -->
          <ListboxOption
            v-for="destination in results"
            :key="destination.id"
            v-slot="{ active, selected }"
            as="template"
            :value="destination"
          >
            <li :class="[active ? 'text-white bg-indigo-600' : 'text-gray-900', 'cursor-default select-none relative py-2 pl-3 pr-9']">
              <div class="flex justify-between">
                <div class="flex flex-row">
                  <img
                    :src="destination.image"
                    alt=""
                    class="flex-shrink-0 h-4 w-6 mt-1.5"
                  >
                  <span :class="[selected ? 'font-semibold' : 'font-normal', 'ml-3 block truncate']">
                    {{ destination.name }}
                  </span>
                </div>
                <div class="flex">
                  <span
                    class="px-2 inline-flex leading-5 font-semibold rounded-full"
                  >
                    {{ destination.area }}</span>
                </div>
              </div>

              <span
                v-if="selected"
                :class="[
                  active ? 'text-white' : 'text-indigo-600',
                  'absolute inset-y-0 left-0 flex items-center pl-1.5',
                ]"
              />
            </li>
          </ListboxOption>
        </ListboxOptions>
      </transition>
    </div>
  </Listbox>
</template>

<script>

import {
  Listbox,
  ListboxButton,
  ListboxLabel,
  ListboxOption,
  ListboxOptions,
} from '@headlessui/vue';
import {
  MagnifyingGlassIcon,
  ChevronUpDownIcon,
} from '@heroicons/vue/24/solid';

export default {
  components: {
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
    ChevronUpDownIcon,
    MagnifyingGlassIcon,
  },
  props: {
    modelValue: {
      required: false,
      default: null,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      searchQuery: '',
      results: [],
      selected: {
        place_id: null,
        name: null,
        image: null,
      },
      result: null,
    };
  },
  watch: {
    searchQuery() {
      if (this.searchQuery.length > 0) {
        this.getDestinations();
      }
    },
    selected: {
      handler() {
        if (this.selected.place_id !== null) {
          this.getDestination(this.selected.place_id);
        }
      },
      deep: true,
    },
  },
  methods: {
    getDestinations() {
      const url = `/api/destinations?search=${
        this.searchQuery}`;
      axios
        .get(url)
        .then((response) => {
          this.results = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getDestination(place_id) {
      const url = `/api/destinations/${place_id}`;
      axios
        .get(url)
        .then((response) => {
          this.result = response.data;
          this.$emit('update:modelValue', this.result.id);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setFocus() {
      this.$refs.searchDestinations.$el.focus();
    },

  },
};
</script>
